export const countDecimalDigits = (value) => {
  if (!value) {
    return null;
  }

  if (Math.floor(value) === Number(value)) {
    // string does not contain decimal
    return 0;
  }

  return value.toString().split('.')[1].length || 0;
};

export const getDecimalDigits = (decimalDigits) => decimalDigits ?? 2;

export const convertToNumber = (value) => {
  const number = value * 1;

  if (Number.isNaN(number)) {
    return 0;
  }

  return number;
};
